import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { CountryListItem } from '@/models/dictionary/country-list.model';

export default class GetCountryListRequest extends ApiResourceMethod<CountryListItem[]> {
  public perform(): Promise<CountryListItem[]> {
    return this.performer.requestWithMapper(
      {},
      ({ data }: BaseResponse<CountryListItem[]>): CountryListItem[] => data,
    );
  }
}
